import * as S from './styles';

export const Card = ({ item }) => {
  const { icon, title, text = [] } = item || {};

  return (
    <S.Card>
      <div className="module">
        <div className="colors blue" />
        <div className="colors pink" />

        <img src={icon} alt="" />

        <S.CardTitle>{title}</S.CardTitle>

        <S.CardBody>{text}</S.CardBody>

      </div>
    </S.Card>
  );
};